import { Injectable, inject } from "@angular/core";
import { MasterUrlService } from "../../configs/api-urls";
import { FinancialDisclosureContactInformationApiModel, FinancialDisclosureReportApiModel, FinancialDisclosureReportTypesApiModel } from "../../shared/components/financial-disclosure-report/financial-disclosure-report.model";
import { Observable } from "rxjs";
import { ApiResponse, IFilingPeriodByElectionCycleApiModel } from "../../app.model";
import { ClientService } from "./client.service";

@Injectable({
    providedIn: "root",
})
export class FinancialDisclosureService {
    readonly urls = inject(MasterUrlService);
    readonly service = inject(ClientService);

    public readonly getContactInformationByFiler = (filerId: number): Observable<FinancialDisclosureContactInformationApiModel> =>
        this.service.getData(this.urls.getContactInformationByFiler + filerId) as Observable<FinancialDisclosureContactInformationApiModel>;
        
    public readonly getContactInformationByFiling = (filingId: number): Observable<FinancialDisclosureContactInformationApiModel> =>
        this.service.getData(this.urls.getContactInformationByFiling + filingId) as Observable<FinancialDisclosureContactInformationApiModel>;

    public readonly getEthicsFinancialDisclosureReportByFiler = (filerId: number, filingPeriodId: number, reportTypeId: number, roleId: number, year?: number): Observable<FinancialDisclosureReportApiModel> => {
        let path = this.urls.getFinancialDisclosureReport + `/${filerId}/period/${filingPeriodId}/${reportTypeId}/${roleId ?? -1}`;

        if (year) path += `?year=${year}`;

        return this.service.getData(path) as Observable<FinancialDisclosureReportApiModel>;
    }

    public readonly getEthicsFinancialDisclosureReportByFiling = (filingId: number): Observable<FinancialDisclosureReportApiModel> =>
        this.service.getData(this.urls.getFinancialDisclosureReport + `/${filingId}`) as Observable<FinancialDisclosureReportApiModel>;

    public readonly getEthicFilingPeriods = (isCandidateSEI: boolean, electionCycleId = 0): Observable<IFilingPeriodByElectionCycleApiModel[]> =>
        this.service.getWithData(this.urls.getCityItemFilingPeriods, { isCandidateSEIPeriod: isCandidateSEI, electionCycleId: electionCycleId });
    
    public readonly submitEthicFinancialDisclosureReport = (report): Observable<boolean> =>
        this.service.postData(this.urls.submitFinancialDisclosureReport, report) as Observable<boolean>;

    public readonly saveEthicFinancialDisclosureReport = (report): Observable<boolean> =>
        this.service.postData(this.urls.saveFinancialDisclosureReport, report) as Observable<boolean>;

    public readonly saveNote = (data): Observable<ApiResponse[]> => this.service.postData(this.urls.updateFilingNote, data) as Observable<ApiResponse[]>;

    public readonly getReportTypeByFilerId = (filerId: number, filingPeriodId): Observable<FinancialDisclosureReportTypesApiModel[]> =>
        this.service.getData(this.urls.getReportTypesByFiler + `/${filerId}/${filingPeriodId}`) as Observable<FinancialDisclosureReportTypesApiModel[]>;
    
    public readonly getLatestFinancialDisclosureReportOriginal = (filerId: number): Observable<FinancialDisclosureReportApiModel> =>
        this.service.getData(this.urls.getLatestFinancialDisclosureReportOriginal + `/${filerId}`) as Observable<FinancialDisclosureReportApiModel>;
}
